export default __webpack_public_path__ + "78a5423481536ea04d6c9d3a9b801709.png";